import Swiper from 'swiper';

var swiper = new Swiper('.swiper-container', {
    initialSlide: 0,
    slidesPerView: 3,
    pagination: {
        el: '.swiper-pagination',
        clickable: true
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
    },
    grabCursor: true,
    breakpoints: {
        // when window width is <= 320px
        992: {
            slidesPerView: 1
        },
        1224: {
            slidesPerView: 2
        }
    }
});
